import { render, staticRenderFns, recyclableRender, components } from "./main.vue?vue&type=template&id=b75bcc16&scoped=true&"
var renderjs
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75bcc16",
  null,
  false,
  components,
  renderjs
)

export default component.exports